// export const CREATE_FRANCHIES_SUCCESS = "@createfranchies/CREATE_FRANCHIES_SUCCESS"
// export const CREATE_COHORT_SUCCESS = "createcohort/CREATE_COHORT_SUCCESS"

export const CREATE_COHORT_SUCCESS = 'CREATE_COHORT_SUCCESS';
export const CREATE_FRANCHISEE_SUCCESS = 'CREATE_FRANCHISEE_SUCCESS';
